// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `empty-contract-accounting-component{height:100%}empty-contract-accounting-component .empty-contract-accounting-component{height:100%}`, "",{"version":3,"sources":["webpack://./src/shared/components/empty-contract-accounting/themes/empty-contract-accounting.component.scss"],"names":[],"mappings":"AAEA,oCACI,WAAA,CACA,yEACI,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
